import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import Tabs from '../common/tab/tabs';
import TabsHeader from '../common/tab/tabsHeader';
import TabsContent from '../common/tab/tabsContent';
import TabHeader from '../common/tab/tabHeader';
import TabContent from '../common/tab/tabContent';
import { init, getList, getDescriptions, setPaginaAtual, getAllData } from './contagemVolumetricaActions';
import axiosInstance from '../main/axios';
import configLocal from '../configuracao/configLocal';

import List from './contagemVolumetricaList';
import SelectConfControlador from '../common/selectdb/selectConfControlador';
import SelectConfGrupoFisico from '../common/selectdb/selectConfGrupoFisico';
import ButtonTooltip from '../common/form/buttonTooltip';

class ControladorContagemVolumetrica extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agrupador: 5,
      printLoading: false,
    };

    // Armazenar filtros e ordenação atuais para impressão
    this.currentTableFilters = [];
    this.currentTableSort = [];

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handlePrint = this.handlePrint.bind(this);
    this.onTableStateChange = this.onTableStateChange.bind(this);
  }

  componentWillMount() {
    this.props.init();
  }

  // Função para capturar mudanças de estado da tabela (filtros, ordenação)
  onTableStateChange(state) {
    this.currentTableFilters = state.filtered || [];
    this.currentTableSort = state.sorted || [];
  }

  handleFilterChange(e) {
    const agrupador = e.target ? e.target.value : this.state.agrupador;
    if (e.target) {
      this.setState({ agrupador });
    }

    // Preservar filtros e ordenação atuais ao trocar agrupamento
    // Usar os valores capturados via onTableStateChange para garantir consistência
    const currentFilters = this.currentTableFilters || [];
    const currentSort = this.currentTableSort || [];

    this.props.getList(0, currentSort, currentFilters, agrupador);
    this.props.setPaginaAtual(0);
    this.props.getDescriptions();
  }

  async handlePrint() {
    try {
      this.setState({ printLoading: true });

      const { descriptions } = this.props;
      const { agrupador } = this.state;

      // Usar os filtros e ordenação que foram salvos automaticamente
      const currentFilters = this.currentTableFilters || [];
      const currentSort = this.currentTableSort || [];

      let allFilteredData = [];
      let controladorInfo = null;

      try {
        // Fazer requisição direta para buscar TODOS os dados (sem paginação)
        const contId = configLocal.getConfig('cont');
        const params = {
          page: 0,
          perPage: 999999, // Buscar todos os registros
          contId,
          sort: currentSort,
          filter: currentFilters,
          agrupador,
          getAllData: 'true', // Flag especial para buscar todos os dados
        };

        const response = await axiosInstance.get('/controladorescontagemvolumetrica', {
          params,
        });

        // Extrair dados da resposta
        if (response && response.data) {
          if (response.data.list) {
            allFilteredData = response.data.list;
          } else if (Array.isArray(response.data)) {
            allFilteredData = response.data;
          } else {
            allFilteredData = response.data.data || [];
          }
        }

        // Buscar informações detalhadas do controlador
        try {
          const grupoId = configLocal.getConfig('grupo');
          const controladorResponse = await axiosInstance.get(`/controladores/${grupoId}/${contId}`);
          if (controladorResponse && controladorResponse.data && controladorResponse.data.length > 0) {
            controladorInfo = controladorResponse.data[0]; // Pega o primeiro resultado
          }
        } catch (controladorError) {
          console.warn('Erro ao buscar informações do controlador:', controladorError);
        }
      } catch (apiError) {
        console.warn('Erro ao buscar todos os dados, usando dados já carregados:', apiError);
        allFilteredData = this.props.data || [];
      }

      if (!allFilteredData || allFilteredData.length === 0) {
        alert('Nenhum dado encontrado para impressão. Verifique se há registros na tabela.');
        return;
      }

      // Gerar HTML para impressão com TODOS os dados filtrados
      const html = this.generatePrintHTML(allFilteredData, descriptions, agrupador, currentFilters, controladorInfo);

      // Abrir nova janela e imprimir
      const janelaImprimir = window.open('', '', 'width=1200,height=800');
      janelaImprimir.document.open();
      janelaImprimir.document.write(html);
      janelaImprimir.document.close();
      janelaImprimir.print();
      janelaImprimir.close();
    } catch (error) {
      console.error('Erro ao imprimir:', error);
      alert(`Erro ao gerar relatório para impressão: ${error.message || error}. Tente novamente.`);
    } finally {
      this.setState({ printLoading: false });
    }
  }

  generatePrintHTML(data, descriptions, agrupador, filters, controladorInfo) {
    const descricoes = descriptions || {};

    // Obter informações do controlador dos dados filtrados ou usar as informações passadas
    const infoControlador = controladorInfo || this.getControladorInfo(data, filters);

    // Criar cabeçalhos das colunas
    let headerHTML = `
      <tr style="background-color: #f8f9fa; font-weight: bold;">
        <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Data Contagem</th>
        <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Hora Contagem</th>`;

    // Adicionar colunas dos laços
    for (let laco = 1; laco <= 16; laco++) {
      let label = `Laço ${laco}`;
      const key = `laco_${laco}`;
      if (descricoes.hasOwnProperty(key)) {
        label = `${label} (${descricoes[key]})`;
      }
      headerHTML += `<th style="border: 1px solid #ddd; padding: 8px; text-align: center;">${label}</th>`;
    }
    headerHTML += '</tr>';

    // Criar linhas de dados
    let rowsHTML = '';
    if (data && data.length > 0) {
      data.forEach(row => {
        rowsHTML += '<tr>';

        // Data e hora
        const dataContagem = new Date(row.data_contagem).toLocaleDateString('pt-BR');
        rowsHTML += `<td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${dataContagem}</td>`;
        rowsHTML += `<td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${row.hora_contagem ||
          ''}</td>`;

        // Laços
        for (let laco = 1; laco <= 16; laco++) {
          const valor = row[`laco_${laco}`] || '0';
          rowsHTML += `<td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${valor}</td>`;
        }

        rowsHTML += '</tr>';
      });
    } else {
      rowsHTML =
        '<tr><td colspan="18" style="border: 1px solid #ddd; padding: 8px; text-align: center;">Nenhum dado encontrado</td></tr>';
    }

    return `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="utf-8">
        <title>Contagem Volumétrica - Relatório</title>
        <style>
          body { 
            font-family: Arial, sans-serif; 
            margin: 20px; 
            font-size: 12px;
          }
          .header { 
            text-align: center; 
            margin-bottom: 20px; 
            border-bottom: 2px solid #000; 
            padding-bottom: 10px;
          }
          .info { 
            margin-bottom: 15px; 
            font-size: 14px;
          }
          table { 
            border-collapse: collapse; 
            width: 100%; 
            margin-top: 10px;
          }
          th, td { 
            border: 1px solid #ddd; 
            padding: 6px; 
            text-align: center;
            font-size: 11px;
          }
          th { 
            background-color: #f8f9fa; 
            font-weight: bold;
          }
          .footer { 
            margin-top: 20px; 
            font-size: 10px; 
            text-align: center;
            border-top: 1px solid #ccc;
            padding-top: 10px;
          }
          @media print {
            body { margin: 0; }
            .header { page-break-inside: avoid; }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <h2>Contagem Volumétrica - Relatório</h2>
        </div>
        
        <div class="info">
          ${this.formatControladorInfo(infoControlador)}
          <strong>Agrupamento:</strong> ${agrupador} minutos<br>
          <strong>Data/Hora da Impressão:</strong> ${new Date().toLocaleString('pt-BR')}<br>
          <strong>Total de Registros:</strong> ${data ? data.length : 0}<br>
          ${this.getFiltersInfo(filters)}
        </div>

        <table>
          ${headerHTML}
          ${rowsHTML}
        </table>

        <div class="footer">
          Relatório gerado pelo Sistema SSAT - ${new Date().toLocaleString('pt-BR')}
        </div>
      </body>
      </html>
    `;
  }

  getFiltersInfo(filters) {
    if (!filters || filters.length === 0) {
      return '<strong>Filtros:</strong> Nenhum filtro aplicado';
    }

    let filtersText = '<strong>Filtros Aplicados:</strong><br>';

    filters.forEach(filter => {
      if (filter.value) {
        switch (filter.id) {
          case 'data_contagem':
            const dataFormatada = new Date(filter.value).toLocaleDateString('pt-BR');
            filtersText += `&nbsp;&nbsp;• Data: ${dataFormatada}<br>`;
            break;
          case 'hora_contagem':
            try {
              const filterData = JSON.parse(filter.value);
              if (filterData.start && filterData.end) {
                filtersText += `&nbsp;&nbsp;• Hora: ${filterData.start} - ${filterData.end}<br>`;
              } else if (filterData.start) {
                filtersText += `&nbsp;&nbsp;• Hora: A partir de ${filterData.start}<br>`;
              } else if (filterData.end) {
                filtersText += `&nbsp;&nbsp;• Hora: Até ${filterData.end}<br>`;
              }
            } catch (e) {
              filtersText += `&nbsp;&nbsp;• Hora: ${filter.value}<br>`;
            }
            break;
          default:
            if (filter.id.startsWith('laco_')) {
              const lacoNum = filter.id.replace('laco_', '');
              filtersText += `&nbsp;&nbsp;• Laço ${lacoNum}: ${filter.value}<br>`;
            }
            break;
        }
      }
    });

    return filtersText;
  }

  formatControladorInfo(controladorInfo) {
    if (!controladorInfo) {
      return '';
    }

    // Se é uma resposta da API, use os campos corretos
    if (controladorInfo.numero_controlador || controladorInfo.endereco) {
      const numero = controladorInfo.numero_controlador || '';
      const endereco = controladorInfo.endereco || '';
      return `<strong>Controlador:</strong> ${numero}${endereco ? ` - ${endereco}` : ''}<br>`;
    }

    // Se é um objeto da função getControladorInfo (compatibilidade)
    if (controladorInfo.numero || controladorInfo.endereco) {
      return `<strong>Controlador:</strong> ${controladorInfo.numero}${
        controladorInfo.endereco ? ` - ${controladorInfo.endereco}` : ''
      }<br>`;
    }

    // Se tem HTML já formatado (compatibilidade)
    if (controladorInfo.html) {
      return controladorInfo.html;
    }

    return '';
  }

  getControladorInfo(data, filters) {
    // Tentar obter informações do controlador a partir dos props ou dados
    const { controladorSelecionado } = this.props;

    let controladorInfo = {
      numero: '',
      endereco: '',
      html: '',
    };

    // Se há controlador selecionado nos props
    if (controladorSelecionado) {
      controladorInfo.numero = controladorSelecionado.numero || controladorSelecionado.id || '';
      controladorInfo.endereco = controladorSelecionado.endereco || controladorSelecionado.ip || '';
    }

    // Se não conseguiu dos props, tentar dos dados
    if (!controladorInfo.numero && data && data.length > 0) {
      const primeiroRegistro = data[0];
      controladorInfo.numero = primeiroRegistro.controlador_numero || primeiroRegistro.numero_controlador || '';
      controladorInfo.endereco = primeiroRegistro.controlador_endereco || primeiroRegistro.endereco || '';
    }

    // Gerar HTML se tiver informações
    if (controladorInfo.numero || controladorInfo.endereco) {
      controladorInfo.html = `<strong>Controlador:</strong> ${controladorInfo.numero}${
        controladorInfo.endereco ? ` (${controladorInfo.endereco})` : ''
      }<br>`;
    }

    return controladorInfo;
  }

  render() {
    return (
      <div>
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label="Listar" icon="bars" target="tabList" />
              <div
                style={{
                  marginLeft: 'auto',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  flexWrap: 'wrap',
                  padding: '4px 12px 4px 0',
                  justifyContent: 'flex-end',
                  minWidth: 'max-content',
                }}
              >
                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                  <label
                    style={{
                      fontSize: '13px',
                      color: '#475569',
                      fontWeight: '600',
                      margin: 0,
                      paddingRight: '4px',
                    }}
                  >
                    Grupo Físico:
                  </label>
                  <SelectConfGrupoFisico
                    onChange={this.handleFilterChange}
                    emptyText="Todos"
                    customStyle={{
                      width: '180px',
                      height: '38px',
                      padding: '7px 10px',
                      fontSize: '13px',
                      fontWeight: '500',
                      border: '1px solid #bfd0e0',
                      borderRadius: '10px',
                      backgroundColor: '#ffffff',
                      color: '#475569',
                      boxShadow: 'none',
                    }}
                  />
                </div>
                <div className="form-group" style={{ margin: 0 }}>
                  <SelectConfControlador
                    onChange={this.handleFilterChange}
                    anel={false}
                    emptyText="Todos"
                    customStyle={{
                      width: '300px',
                      height: '38px',
                      padding: '7px 10px',
                      fontSize: '13px',
                      fontWeight: '500',
                      border: '1px solid #bfd0e0',
                      borderRadius: '10px',
                      backgroundColor: '#ffffff',
                      color: '#475569',
                      boxShadow: 'none',
                    }}
                  />
                </div>
                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                  <label
                    htmlFor="agrupador"
                    style={{
                      fontSize: '13px',
                      color: '#475569',
                      fontWeight: '600',
                      margin: 0,
                    }}
                  >
                    Agrupar:
                  </label>
                  <select
                    id="agrupador"
                    className="form-control"
                    style={{
                      width: '95px',
                      height: '38px',
                      padding: '7px 10px',
                      fontSize: '13px',
                      fontWeight: '500',
                      border: '1px solid #bfd0e0',
                      borderRadius: '10px',
                      backgroundColor: '#ffffff',
                      color: '#475569',
                      boxShadow: 'none',
                    }}
                    value={this.state.agrupador}
                    onChange={this.handleFilterChange}
                  >
                    <option value="5">5 min</option>
                    <option value="10">10 min</option>
                    <option value="15">15 min</option>
                    <option value="30">30 min</option>
                    <option value="60">60 min</option>
                  </select>
                </div>
                <ButtonTooltip
                  type="button"
                  icon={this.state.printLoading ? 'spinner fa-spin' : 'print'}
                  label="Imprimir"
                  className="default"
                  data-title={this.state.printLoading ? 'Gerando relatório...' : 'Imprimir Relatório'}
                  onClick={this.handlePrint}
                  disabled={this.state.printLoading}
                />
              </div>
            </TabsHeader>
            <TabsContent>
              <TabContent id="tabList">
                <List
                  ref="listComponent"
                  agrupador={this.state.agrupador}
                  onTableStateChange={this.onTableStateChange}
                />
              </TabContent>
            </TabsContent>
          </Tabs>
        </Content>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  data: state.controladorContagemVolumetrica.list,
  descriptions: state.controladorContagemVolumetrica.descriptions,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ init, getList, getDescriptions, setPaginaAtual, getAllData }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ControladorContagemVolumetrica);
